var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8999 6.50029C3.8999 6.10029 4.0999 5.80029 4.3999 5.80029H8.09991C8.49991 5.80029 8.69991 6.10029 8.69991 6.50029C8.69991 6.80029 8.49991 7.10029 8.09991 7.10029H4.3999C4.1999 7.10029 3.8999 6.80029 3.8999 6.50029Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50005 0.900391H9.10005C10.6001 0.900391 11.8 2.10039 11.8 3.60039V9.20039C11.8 10.7004 10.6001 11.9004 9.10005 11.9004H3.50005C2.00005 11.9004 0.800049 10.7004 0.800049 9.20039V3.60039C0.800049 2.10039 2.00005 0.900391 3.50005 0.900391Z",
    stroke: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMin);
export default __webpack_public_path__ + "static/media/min.6fe744309edfd05c56a8115b7177bb90.svg";
export { ForwardRef as ReactComponent };